/* eslint-disable import/no-anonymous-default-export */

export default {
  enter: 'Enter',
}
